import React from 'react';
import { Stack, Typography } from '@mui/material';
import { BtnsTabsContainer } from 'components/shared/TabsContainer/BtnsTabsContainer';

interface Props {
  workflow: any | null;
}

export const SalesCenterRules = ({ workflow }: Props) => {
  if (!workflow) return null;

  const allRulesString = Object.entries(workflow.dealRules)
    .filter(([key, value]) => !!value && !key.startsWith('_'))
    .map(([_, value]) => value)
    .join(' + ');

  return (
    <Stack className="salesCenterCard" gap="1rem" height="100%">
      <Typography variant="h6" component="span">
        Configure Rule: {allRulesString}
      </Typography>

      <BtnsTabsContainer
        configuration={[
          { key: 'fees', label: 'Fees Configuration' },
          { key: 'taxes', label: 'Taxes Configuration' },
        ]}
        renderNestedSectionByMode={{
          fees: <>Fees</>,
          taxes: <>Taxes</>,
        }}
      />
    </Stack>
  );
};
